import { Box, Button, Typography } from '@mui/material';
import { legalApproval } from 'API/compassRights';
import { DynamicArrow } from 'Components/DynamicArrow';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IUserApproval {
  setModalAgreementBox: Function;
  userAgreement: boolean;
  setShowAgreementErrorMessage: Function;
}

export const UserApproval = ({
  setModalAgreementBox,
  userAgreement,
  setShowAgreementErrorMessage,
}: IUserApproval) => {
  const isDesktop = useIsDesktop();

  async function modalAgreement() {
    if (userAgreement) {
      setModalAgreementBox(true);

      await legalApproval();
    } else {
      setShowAgreementErrorMessage(true);
    }
  }

  return (
    <Button
      role='button'
      variant='primary'
      sx={{
        borderRadius: '100px',
        whiteSpace: 'nowrap',
        width: isDesktop ? '234px' : '208px',
        height: isDesktop ? 'auto' : '44px',
        padding: isDesktop ? '12px 24px' : '10px 24px',
        gap: isDesktop ? '4px' : '10px',
        zIndex: 1,
      }}
      onClick={modalAgreement}
    >
      <Typography variant={'body4'} color={'#fff'}>
        {
          Dictionary[DICTIONARY.CompassRights].agreementModal
            .sendRequestAgreement
        }
      </Typography>
      <Box
        sx={{
          transform: 'rotate(90deg)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DynamicArrow color={'#fff'} />
      </Box>
    </Button>
  );
};
